import styled from "styled-components";

export const IconTextTooltipStyles = styled.div`
  display: flex;
  align-items: center;

  .iconContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
    background: transparent;
  }

  .text {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b3.weight};
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    letter-spacing: 0.1px;
    margin-left: ${({ theme }) => theme.spacing[12]};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .tooltip {
    background: ${({ theme }) => theme.colors.semantic.container.white} !important;
    border-radius: ${({ theme }) => theme.radius[4]};
    opacity: 1 !important;
  }

  .tooltip .react-tooltip-arrow {
    border-color: ${({ theme }) => theme.colors.semantic.container.white};
  }

  .tooltipText {
    font-style: normal;
    font-weight: ${({ theme }) => theme.typography.body.b3.weight};
    font-size: 10px;
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    text-align: center;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }
`;
